/* template */
<template><page><base-container><view-desc>复选框 - 默认圆形</view-desc><div :class='["item","cube-example"]'><cube-round></cube-round></div><view-desc>复选框 - 使用 slot</view-desc><div :class='["item","cube-example"]'><cube-group-slot></cube-group-slot></div><view-desc>复选框使用行内样式：inline - true</view-desc><div :class='["item","cube-example"]'><cube-round-inline></cube-round-inline></div><view-desc>复选框使用禁用项：disabled - true</view-desc><div :class='["item","cube-example"]'><cube-round-disabled></cube-round-disabled></div><view-desc>复选框 - 使用方形</view-desc><div :class='["item","cube-example"]'><cube-square></cube-square></div><view-desc>复选框 - 使用方形默认选中</view-desc><div :class='["item","cube-example"]'><cube-square-selected></cube-square-selected></div><view-desc>复选框 - 规定一行显示个数</view-desc><div :class='["item","cube-example"]'><cube-square-column-num></cube-square-column-num></div></base-container></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_6853354a"}'>
.cube-checkbox-group-example
  background-color #fff
  padding 5px 10px

  .desc
    padding-top 10px

.view-desc
  margin 10px 0
.base-container
  background-color rgba(239, 239, 244, .7)
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_6853354a"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_6853354a"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_6853354a"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {"styleIsolation":"shared"},
    // @ts-ignore
    componentsMap: {'cube-group-slot':getComponent(require("./group-slot.mpx?isComponent&outputPath=components%2Fgroup-slot14234ad1%2Findex")),'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'view-desc':getComponent(require("../../components/desc/index.mpx?isComponent&outputPath=components%2Findex590d50a3%2Findex")),'cube-round':getComponent(require("./round.mpx?isComponent&outputPath=components%2Fround08a99fd2%2Findex")),'cube-round-inline':getComponent(require("./round-inline.mpx?isComponent&outputPath=components%2Fround-inline3241a07d%2Findex")),'cube-round-disabled':getComponent(require("./round-disabled.mpx?isComponent&outputPath=components%2Fround-disabledd37508c0%2Findex")),'cube-square':getComponent(require("./square.mpx?isComponent&outputPath=components%2Fsquare01aa55e2%2Findex")),'cube-square-selected':getComponent(require("./square-selected.mpx?isComponent&outputPath=components%2Fsquare-selected04b53ad4%2Findex")),'cube-square-column-num':getComponent(require("./square-column-num.mpx?isComponent&outputPath=components%2Fsquare-column-num0fe8f248%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>